import type { ErrorEnvelopeView } from '@skm/ui';
import { ApiError } from '../api/client.ts';

/** API failure → what ErrorBanner shows (code, message key, scalar params, request id). */
export function errorView(e: unknown): ErrorEnvelopeView {
  if (!(e instanceof ApiError)) return { code: 'INTERNAL', messageKey: 'errors.code.INTERNAL' };
  const params = Object.fromEntries(
    Object.entries(e.body.params ?? {}).filter(
      (p): p is [string, string | number] => typeof p[1] === 'string' || typeof p[1] === 'number',
    ),
  );
  return {
    code: e.body.code,
    messageKey: e.body.messageKey,
    params,
    ...(e.body.requestId ? { requestId: e.body.requestId } : {}),
  };
}
